module.exports = __webpack_public_path__ + "1e716963a74c70c4ce435832067aeabf.png";